import Pusher from 'pusher-js';

import { getClientId } from '../../utils/client';
import { api } from '../../utils/bookboost/api';

const getPresenceChannel = (integrationId) =>
    `presence-device-${getClientId(integrationId)}`;

let pusher = null;

export const updatePresenceChannel = () => (dispatch, getState) => {
    const state = getState();
    const { user, bbConfig, config: {integrationId} } = state;

    if (!user.conversationStarted) {
        return;
    }

    if (!pusher) {
        const { key, cluster } = bbConfig.pusherInfo;

        const { document: _document } = parent;
        const href = _document.location && _document.location.href;

        pusher = new Pusher(key, {
            cluster,
            authEndpoint: api(state).pusherAuthEndpoint(),
            auth: {
                headers: {
                    ...api(state).authHeaders(),
                    'X-CURRENT-URL': href,
                    'X-CURRENT-TITLE': _document.title
                }
            },
            encrypted: true
        });
        const presenceChannel = getPresenceChannel(integrationId);
        pusher.subscribe(presenceChannel);
        console.debug(`Subscribed to ${presenceChannel}`);
    }
};
